import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '../services/firebase.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {FileUpload} from '../model/file-upload';
import {UploadFileService} from '../services/upload-file.service';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PandsFileUpload } from '../model/pands-file-upload';
import { GalFileUpload } from '../model/gal-file-upload';

@Component({
  selector: 'app-card-creator',
  templateUrl: './card-creator.component.html',
  styleUrls: ['./card-creator.component.css']
})
export class CardCreatorComponent implements OnInit {

username: any;
phone:any;
createddate:any;
obj : any;
pandsblock : any;
checker!: any;
if_reference_code_exist : any;
  selectedFiles: FileList;
  currentFileUpload: FileUpload;
  percentage: number;

  pands_selectedFiles: FileList;
  pands_currentFileUpload: FileUpload;
  pands_percentage: number;

  gal_selectedFiles: FileList;
  gal_currentFileUpload: FileUpload;
  gal_percentage: number;


user_mail!:string;
  // value show
  // basicdetails
  userfirstname!:string;
  usermiddlename!:string;
  userlastname!:string;
  profileurl!:string;
  companyname!:string;
  natureofbusiness!:string;
  posdesig!:string;
  phoneshow!:string;
  aphone!:string;
  landline!:string;
  whatsapp!:string;
  email!:string;
  website!:string;
  address!:string;
  // social media
  facebook!:string;
  instagram!:string;
  linkedin!:string;
  messenger!:string;
  telegram!:string;
  twitter!:string;
  youtube!:string;
// payment details
  gpayname !: string;
  gpay !: string;
  // paytm !: string;
  phonepename !: string;
  phonepe !: string;
  bankname !: string;
  accountholdername !: string;
  accountnumber !: string;
  ifsc !: string;
  savingscurrent !: string;


  // enquiry form
enemail !: string;
// Aboutus
abtus!: string;

  constructor(private router: Router, public firebaseService: FirebaseService,
    private firestore: AngularFirestore, private uploadService: UploadFileService ) {

    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
  };
  this.user_mail = this.obj.email;
     this.firestore.collection("users").ref.where("username", "==", this.obj.email).onSnapshot(snap =>{
          snap.forEach(userRef => {
            this.username = userRef.data()["name"];
            this.phone = userRef.data()["phoneno"];
            this.if_reference_code_exist = userRef.data()["reference_code"];
            if(this.if_reference_code_exist){
              var elementsrefblock= document.getElementById('reference');
              elementsrefblock.className = "display_none";
              var elementsrefblock= document.getElementById('ref_nav_id');
              elementsrefblock.className = "display_none";
              var elementsrefalt= document.getElementById('alt_reference');
              elementsrefalt.className = "display_alt";
              var elementsrefnav= document.getElementById('ref_alt_nav_id');
              elementsrefnav.className = "display_alt";
            }else{
              var elementsref= document.getElementById('alt_reference');
              elementsref.className = "display_none";
              var elementsref= document.getElementById('ref_alt_nav_id');
              elementsref.className = "display_none";
              var elementsref= document.getElementById('ref_nav_id');
              elementsref.className = "display_alt";
              var elementsrefblock= document.getElementById('reference');
              elementsrefblock.className = "display_alt";
            }
          })});

          var docRef = this.firestore.collection("users").doc(this.obj.email);
          docRef.get().forEach((doc) => {
            if (doc.exists) {
              if(doc.data()["package"] === 'basic'){
                // products and services
                var elementsbasic= document.getElementById('basicpandsbasic');
                elementsbasic.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                var elementsbusiness= document.getElementById('busipandsbusiness');
                elementsbusiness.className = "display_none";
                var elementsprof= document.getElementById('profpandsprof');
                elementsprof.className = "display_none";

                //gallery basic
                var elementsgalbasic= document.getElementById('profbasicgal');
                elementsgalbasic.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                var elementsgalbusiness= document.getElementById('profbusgal');
                elementsgalbusiness.className = "display_none";
                var elementsgalprof= document.getElementById('profprofgal');
                elementsgalprof.className = "display_none";
              }else if(doc.data()["package"] === 'business'){
                // products and services
                var elementsbusiness= document.getElementById('busipandsbusiness');
                elementsbusiness.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                var elementsbasic= document.getElementById('basicpandsbasic');
                elementsbasic.className = "display_none";
                var elementsprof= document.getElementById('profpandsprof');
                elementsprof.className = "display_none";
                //gallery basic
                var elementsgalbasic= document.getElementById('profbasicgal');
                elementsgalbasic.className = "display_none";
                var elementsgalbusiness= document.getElementById('profbusgal');
                elementsgalbusiness.className = "col-lg-12 mt-5 mt-lg-0  display_pands";
                var elementsgalprof= document.getElementById('profprofgal');
                elementsgalprof.className = "display_none";
              }else if(doc.data()["package"] === 'professional'){


                // products and services
                var elementsbasic= document.getElementById('basicpandsbasic');
                elementsbasic.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                var elementsbusiness= document.getElementById('busipandsbusiness');
                elementsbusiness.className = "display_none";
                var elementsprof= document.getElementById('profpandsprof');
                elementsprof.className = "display_none";
                 //gallery basic
                 var elementsgalbasic= document.getElementById('profbasicgal');
                 elementsgalbasic.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                 var elementsgalbusiness= document.getElementById('profbusgal');
                 elementsgalbusiness.className = "display_none";
                 var elementsgalprof= document.getElementById('profprofgal');
                 elementsgalprof.className = "display_none";
              }else{

                // products and services
                var elementsprof= document.getElementById('profpandsprof');
                elementsprof.className = "col-lg-12 mt-5 mt-lg-0 display_pands";
                var elementsbusiness= document.getElementById('busipandsbusiness');
                elementsbusiness.className = " display_none";
                var elementsbasic= document.getElementById('basicpandsbasic');
                elementsbasic.className = "display_none";
                //gallery basic
                var elementsgalbasic= document.getElementById('profbasicgal');
                elementsgalbasic.className = "display_none";
                var elementsgalbusiness= document.getElementById('profbusgal');
                elementsgalbusiness.className = "display_none";
                var elementsgalprof= document.getElementById('profprofgal');
                elementsgalprof.className = "col-lg-12 mt-5 mt-lg-0  display_pands ";
              }





          // this.pandsblock = doc.data()["package"];
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

         // basic details
      this.firestore.collection("basicdetails").ref.doc(this.obj.email)
      .get()
      .then((querySnapshot) => {

        if(querySnapshot.exists){
              this.userfirstname = querySnapshot.data()['firstname'];
              this.usermiddlename = querySnapshot.data()['middlename'];
              this.userlastname = querySnapshot.data()['lastname'];
              this.profileurl = querySnapshot.data()['profileurl'];
              this.companyname = querySnapshot.data()['companyname'];
              this.natureofbusiness = querySnapshot.data()['natureofbusiness'];
              this.posdesig = querySnapshot.data()['posdesig'];
              this.phoneshow = querySnapshot.data()['phone'];
              this.aphone = querySnapshot.data()['aphone'];
              this.landline = querySnapshot.data()['landline'];
              this.whatsapp = querySnapshot.data()['whatsapp'];
              this.email = querySnapshot.data()['email'];
              this.website = querySnapshot.data()['website'];
              this.address = querySnapshot.data()['address'];
            }
      })
      .catch((error) => {
          console.log("Error getting documents: ", error);
      });
// social media details
this.firestore.collection("socialmedia").ref.doc(this.obj.email)
.get()
.then((querySnapshot) => {
  if(querySnapshot.exists){
        this.facebook = querySnapshot.data()['facebook'];
        this.instagram = querySnapshot.data()['instagram'];
        this.linkedin = querySnapshot.data()['linkedin'];
        this.messenger = querySnapshot.data()['messenger'];
        this.telegram = querySnapshot.data()['telegram'];
        this.twitter = querySnapshot.data()['twitter'];
        this.youtube = querySnapshot.data()['youtube'];
      }
})
.catch((error) => {
    console.log("Error getting documents: ", error);
});


 // Payment Details
 this.firestore.collection("paymentdetails").ref.doc(this.obj.email)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.gpayname = querySnapshot.data()['gpayname'];
         this.gpay = querySnapshot.data()['gpay'];
        //  this.paytm = querySnapshot.data()['paytm'];
        this.phonepename = querySnapshot.data()['phonepename'];
         this.phonepe = querySnapshot.data()['phonepe'];
         this.bankname = querySnapshot.data()['bankname'];
         this.accountholdername = querySnapshot.data()['accountholdername'];
         this.accountnumber = querySnapshot.data()['accountnumber'];
         this.ifsc = querySnapshot.data()['ifsc'];
         this.savingscurrent = querySnapshot.data()['savingscurrent'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });



 // enquiry Details
 this.firestore.collection("enquirydetails").ref.doc(this.obj.email)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.enemail = querySnapshot.data()['enqmail'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });

 // aboutus Details
 this.firestore.collection("aboutus").ref.doc(this.obj.email)
 .get()
 .then((querySnapshot) => {
   if(querySnapshot.exists){
        this.abtus = querySnapshot.data()['aboutus'];
        }
 })
 .catch((error) => {
     console.log("Error getting documents: ", error);
 });




  }

  // reference code
  public referenceForm = new FormGroup({
    refcode: new FormControl('', Validators.required)

  });
  reference_code(formData: FormData){
    let update_details={
      reference_code: formData["refcode"],
    }
    this.firestore.collection("users").doc(this.obj.email).update(update_details)
    .then(user => {
      var elements= document.getElementById('succ');
    elements.className = " saved-ref";
    console.log("updated date");
     }).catch(err => {
      console.log(err);
    })
      this.router.navigate(['/card-creator']);
    // this.router.navigate(['/card-creator']);
  }
// package
  public packForm = new FormGroup({
    pack: new FormControl('', Validators.required)

  });
  pack_det(formData: FormData){
    let update_details={
      package: formData["pack"],
    }
    this.firestore.collection("users").doc(this.obj.email).update(update_details)
    .then(user => {
      var elements= document.getElementById('pack-succ');
    elements.className = " saved-ref";
    console.log("updated date");
     }).catch(err => {
      console.log(err);
    })
    this.router.navigate(['/card-creator']);
    // this.router.navigate(["/card-creator"]);

  }
  // basic details
  basic_alt_det(bfirstname:string,bmiddlename:string,
    blastname:string,bposdesig:string,bcompanyname:string,
    bnatureofbusiness:string,baddress:string,bphone:string,
    baphone:string,blandline:string,bemail:string,bwhatsapp:string,bwebsite:string){
    let update_details={
      firstname: bfirstname,
      middlename: bmiddlename,
      lastname: blastname,
      posdesig: bposdesig,
      companyname: bcompanyname,
      natureofbusiness: bnatureofbusiness,
      address: baddress,
      phone: bphone,
      aphone: baphone,
      landline: blandline,
      email: bemail,
      whatsapp: bwhatsapp,
      website:bwebsite
    }

    this.firestore.collection("basicdetails").ref.doc(this.obj.email)
      .get()
      .then((querySnapshot) => {

        if(querySnapshot.exists){
          this.firestore.collection("basicdetails").doc(this.obj.email).update(update_details)
          .then(user => {

            var elements= document.getElementById('bs-succ');
          elements.className = " saved-ref";
          this.router.navigate(['/card-creator']);

           }).catch(err => {
            console.log(err);
          })
            }else{
              this.firestore.collection("basicdetails").doc(this.obj.email).set(update_details)
              .then(user => {
                var elements= document.getElementById('bs-succ');
              elements.className = " saved-ref";
              this.router.navigate(['/card-creator']);
            }).catch(err => {
              console.log(err);
            })
            }
      })
      .catch((error) => {
          console.log("Error getting documents: ", error);
      });
  }
  // social media details
  public smiForm = new FormGroup({
    fblink: new FormControl('',Validators.maxLength(50)),
    insta: new FormControl('',Validators.maxLength(50)),
    mes: new FormControl('',Validators.maxLength(50)),
    twit: new FormControl('',Validators.maxLength(50)),
    yt: new FormControl('',Validators.maxLength(50)),
    liin: new FormControl('',Validators.maxLength(50)),
    tele: new FormControl('',Validators.maxLength(50)),
  });
  smi_det(sfacebook:string,sinstagram:string,
    smessenger:string,stwitter:string,
    syoutube:string,slinkedin:string,
    stelegram:string){
    let update_details={

      facebook: sfacebook,
      instagram: sinstagram,
      messenger: smessenger,
      twitter: stwitter,
      youtube: syoutube,
      linkedin: slinkedin,
      telegram: stelegram

    }
    this.firestore.collection("socialmedia").ref.doc(this.obj.email)
      .get()
      .then((querySnapshot) => {

        if(querySnapshot.exists){
          this.firestore.collection("socialmedia").doc(this.obj.email).update(update_details)
          .then(user => {

            var elements= document.getElementById('smi-succ');
          elements.className = " saved-ref";
          this.router.navigate(['/card-creator']);

           }).catch(err => {
            console.log(err);
          })
            }else{
              this.firestore.collection("socialmedia").doc(this.obj.email).set(update_details)
              .then(user => {
                var elements= document.getElementById('smi-succ');
              elements.className = " saved-ref";
              this.router.navigate(['/card-creator']);
            }).catch(err => {
              console.log(err);
            })
            }
      })
      .catch((error) => {
          console.log("Error getting documents: ", error);
      });
  }
// payment details
payment_det(gpayname:string,gpay:string,phpename:string,phonepe:string,bankname:string,
  accountholdername:string,accountnumber:string,ifsc:string,savingscurrent:string){
  let update_details={
    gpayname: gpayname,
    gpay: gpay,
    phpename: phpename,
    phonepe: phonepe,
    bankname: bankname,
    accountholdername: accountholdername,
    accountnumber: accountnumber,
    ifsc: ifsc,
    savingscurrent: savingscurrent

  }

  this.firestore.collection("paymentdetails").ref.doc(this.obj.email)
  .get()
  .then((querySnapshot) => {

    if(querySnapshot.exists){
      this.firestore.collection("paymentdetails").doc(this.obj.email).update(update_details)
      .then(user => {

        var elements= document.getElementById('pay-succ');
      elements.className = " saved-ref";
      this.router.navigate(['/card-creator']);

       }).catch(err => {
        console.log(err);
      })
        }else{
          this.firestore.collection("paymentdetails").doc(this.obj.email).set(update_details)
          .then(user => {
            console.log('Done');
            var elements= document.getElementById('pay-succ');
          elements.className = " saved-ref";
          this.router.navigate(['/card-creator']);
        }).catch(err => {
          console.log(err);
        })
        }
  })
  .catch((error) => {
      console.log("Error getting documents: ", error);
  });
}
// enquiry details
public enqForm = new FormGroup({
  enmail: new FormControl('',Validators.maxLength(50)),

});
enq_det(formData: FormData){
  let update_details={

    enqmail: formData["enmail"],


  }
  this.firestore.collection("enquirydetails").doc(this.obj.email).set(update_details)
  .then(user => {
    var elements= document.getElementById('enq-succ');
  elements.className = " saved-ref";
  this.router.navigate(['/card-creator']);

   }).catch(err => {
    console.log(err);
  })
}

// aboutus details
public aboutForm = new FormGroup({
  aboutusfield: new FormControl('',Validators.maxLength(500)),

});
aboutus_det(formData: FormData){
  let update_details={

    aboutus: formData["aboutusfield"],


  }
  this.firestore.collection("aboutus").doc(this.obj.email).set(update_details)
  .then(user => {
    var elements= document.getElementById('aboutus-succ');
  elements.className = " saved-ref";
  this.router.navigate(['/card-creator']);

   }).catch(err => {
    console.log(err);
  })
}


// File upload
selectFile(event) {
  this.selectedFiles = event.target.files;
}
// gal upload
gal_selectFile(event) {
  this.gal_selectedFiles = event.target.files;
}

upload() {
  const file = this.selectedFiles.item(0);
  this.selectedFiles = undefined;
  this.currentFileUpload = new FileUpload(file);
  this.uploadService.pushFileToStorage(this.currentFileUpload).subscribe(
    percentage => {
      this.percentage = Math.round(percentage);
    },
    error => {
      console.log(error);
    }
  );
}

// products and services
// Basic selection
// File upload
pands_selectFile(event) {
  this.pands_selectedFiles = event.target.files;
}

pandsupload(rowid: string) {
  const file = this.pands_selectedFiles.item(0);
  this.pands_selectedFiles = undefined;
  this.pands_currentFileUpload = new PandsFileUpload(file);
  this.uploadService.push_pands_FileToStorage(this.pands_currentFileUpload,rowid).subscribe(
    pands_percentage => {
      this.pands_percentage = Math.round(pands_percentage);
    },
    error => {
      console.log(error);
    }
  );
}

galupload(rowid: string) {
  const file = this.gal_selectedFiles.item(0);
  this.gal_selectedFiles = undefined;
  this.gal_currentFileUpload = new GalFileUpload(file);
  this.uploadService.push_gallery_FileToStorage(this.gal_currentFileUpload,rowid).subscribe(
    pands_percentage => {
      this.pands_percentage = Math.round(pands_percentage);
    },
    error => {
      console.log(error);
    }
  );
}
click_event_but(a : string,b : string, c : string){

  let update_details={
    rowid: a,
    productname: b,
    productprice: c,
  }
  this.firestore.collection("productsandservices").doc(this.obj.email).collection(a).doc(a).set(update_details)
  .then(user => {
  //   var elements= document.getElementById('enq-succ');
  // elements.className = " saved-ref";
  // this.router.navigate(["#"]);

   }).catch(err => {
    console.log(err);
  })

  this.pandsupload(a);

}

click_event_gal(a : string){

  let update_details={
    rowid: a,
  }
  this.firestore.collection("gallery").doc(this.obj.email).collection(a).doc(a).set(update_details)
  .then(user => {
  //   var elements= document.getElementById('enq-succ');
  // elements.className = " saved-ref";
  // this.router.navigate(["#"]);

   }).catch(err => {
    console.log(err);
  })

  this.galupload(a);

}
rowbasic: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
]

// business selection

rowbusiness: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
  {rowno:'6'},
  {rowno:'7'},
  {rowno:'8'},
  {rowno:'9'},
  {rowno:'10'}
]

// professional selection
rowprof: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
  {rowno:'6'},
  {rowno:'7'},
  {rowno:'8'},
  {rowno:'9'},
  {rowno:'10'},
  {rowno:'11'},
  {rowno:'12'},
  {rowno:'13'},
  {rowno:'14'},
  {rowno:'15'},
  {rowno:'16'},
  {rowno:'17'},
  {rowno:'18'},
  {rowno:'19'},
  {rowno:'20'},
]

// Gallery
// Basic selection

rowgalbasic: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
  {rowno:'6'},
  {rowno:'7'},
  {rowno:'8'},
  {rowno:'9'},
  {rowno:'10'}
]

// business selection

rowgalbus: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
  {rowno:'6'},
  {rowno:'7'},
  {rowno:'8'},
  {rowno:'9'},
  {rowno:'10'},
  {rowno:'11'},
  {rowno:'12'},
  {rowno:'13'},
  {rowno:'14'},
  {rowno:'15'},
  {rowno:'16'},
  {rowno:'17'},
  {rowno:'18'},
  {rowno:'19'},
  {rowno:'20'},
  {rowno:'21'},
  {rowno:'22'},
  {rowno:'23'},
  {rowno:'24'},
  {rowno:'25'},
]

// professional selection
rowgalprof: ROWNO[] =[
  {rowno:'1'},
  {rowno:'2'},
  {rowno:'3'},
  {rowno:'4'},
  {rowno:'5'},
  {rowno:'6'},
  {rowno:'7'},
  {rowno:'8'},
  {rowno:'9'},
  {rowno:'10'},
  {rowno:'11'},
  {rowno:'12'},
  {rowno:'13'},
  {rowno:'14'},
  {rowno:'15'},
  {rowno:'16'},
  {rowno:'17'},
  {rowno:'18'},
  {rowno:'19'},
  {rowno:'20'},
  {rowno:'21'},
  {rowno:'22'},
  {rowno:'23'},
  {rowno:'24'},
  {rowno:'25'},
  {rowno:'26'},
  {rowno:'27'},
  {rowno:'28'},
  {rowno:'29'},
  {rowno:'30'},
  {rowno:'31'},
  {rowno:'32'},
  {rowno:'33'},
  {rowno:'34'},
  {rowno:'35'},
  {rowno:'36'},
  {rowno:'37'},
  {rowno:'38'},
  {rowno:'39'},
  {rowno:'40'},
  {rowno:'41'},
  {rowno:'42'},
  {rowno:'43'},
  {rowno:'44'},
  {rowno:'45'},
  {rowno:'46'},
  {rowno:'47'},
  {rowno:'48'},
  {rowno:'49'},
  {rowno:'50'},
]



  userdetails(usermail : any): void{

  }
payment(){
  var obj = JSON.parse(localStorage.getItem('user')|| '{}');
  // obj.email
  let update_details={
    enddate: this.firebaseService.addDays(new Date(), 365),
    paid_status: 'Paid',

  }
  this.firestore.collection("users").doc(obj.email).update(update_details)
  .then(user => {
  console.log("updated date");
   }).catch(err => {
    console.log(err);
  })
}
  ngOnInit(): void {
    this.obj = JSON.parse(localStorage.getItem('user')|| '{}');

  }
  logout(){
    this.firebaseService.logOut();
    // this.router.navigateByUrl('/login');
  }
    mob_click(){
    var elements= document.getElementById('main');
    elements.className = " mobile-nav-active1";
    let btn = document.getElementById("mobu");
    if(btn.className === "bi bi-x mobile-nav-toggle1 d-xl-none"){
    btn.className = "bi bi-list mobile-nav-toggle1 d-xl-none";
    elements.className = "";
    }else{
    btn.className = "bi bi-x mobile-nav-toggle1 d-xl-none";
    }
    }
}


class ROWNO {
  rowno : string;
}
